<template>
  <div class="user_container">
    <div class="carManageContainer">
      <van-form ref="form">
        <div class="carInfo">
          <van-cell-group>
            <van-field
              v-model="carInfo.carBrand"
              :rules="[{ required: true }]"
              label="车牌号码："
              placeholder="请输入车牌号码"
            />
          </van-cell-group>
        </div>
        <div class="carInfo">
          <van-cell-group>
            <van-field
              readonly
              clickable
              name="picker"
              :value="carInfo.brandType"
              label="是否显示车牌"
              placeholder="点击选择"
              @click="showPickerBrand = true"
            />
            <van-popup v-model="showPickerBrand" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsBrand"
                @confirm="onConfirmBrand"
                @cancel="showPickerBrand = false"
              />
            </van-popup>
          </van-cell-group>
        </div>
        <div class="carInfo">
          <van-cell-group>
            <van-field
              v-model="carInfo.maxCapacity"
              :rules="[{ required: true }]"
              type="digit"
              label="容纳人数"
              placeholder="请输入容纳人数"
            />
          </van-cell-group>
        </div>
        <div class="carInfo">
          <van-cell-group>
            <van-field
              readonly
              clickable
              name="picker"
              :value="carInfo.type"
              label="是否固定司机"
              placeholder="点击选择"
              @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
          </van-cell-group>
        </div>
        <div class="carInfo">
          <van-cell-group>
            <van-field
              v-model="carInfo.driverName"
              label="司机"
              placeholder="请填写选择司机"
              :rules="[{ required: true }]"
              @focus="selectDriver"
            >
              <template #button>
                <div @click="selectDriver">
                  <img
                    src="@/assets/car/bottomArrows.png"
                    alt=""
                    style="width: 12px; height: 8px"
                  />
                </div>
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <div class="carInfo">
          <van-cell-group>
            <van-field
              v-model="carInfo.driverPhone"
              :rules="[{ required: true }, tel]"
              label="联系方式："
              placeholder="请填写联系方式"
            />
          </van-cell-group>
        </div>
        <div class="carInfo">
          <van-cell-group>
            <van-field
              v-model="carInfo.remarks"
              rows="5"
              autosize
              label="备注"
              type="textarea"
              placeholder="请输入备注"
            />
          </van-cell-group>
        </div>
      </van-form>
    </div>
    <div class="footerBtn">
      <div>
        <van-button
          @click="cancel"
          type="default"
          size="small"
          style="width: 30%"
          >取消</van-button
        >
        <van-button
          :disabled="btnloading"
          type="info"
          size="small"
          @click="confirm"
          style="width: 70%; background-color: #4ea27c"
          >确认</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car.js";
export default {
  name: "addCar",
  props: {},
  components: {},
  data() {
    return {
      depament: null,
      tel: {
        // 自定义校验规则
        validator: (value) => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
            value
          );
        },
        message: "请输入正确格式的手机号码",
        trigger: "onBlur",
      },
      carInfo: {
        carBrand: "",
        maxCapacity: null,
        driverName: "",
        driverPhone: "",
        remarks: "",
        driverCode: "",
        oid: "", //tree 默认展示id
        type:'是',
        brandType:'否'
      },
      btnloading: false,
      showPicker:false,
      showPickerBrand:false,
      columns: ['是', '否'],
      columnsBrand: ['是', '否'],
    };
  },
  created() {
    this.btnloading = false;
    // this.carInfo = this.$store.state.cardetailInfo;
  },
  mounted() {
    //编辑带过来的信息
    if (JSON.parse(localStorage.getItem("driverCarInfo"))) {
      this.carInfo = JSON.parse(localStorage.getItem("driverCarInfo"));
      this.carInfo.type == '1' ? this.carInfo.type = '是' : this.carInfo.type = '否'
      this.carInfo.brandType == '1' ? this.carInfo.brandType = '是' : this.carInfo.brandType = '否'
      console.log("carInfo", this.carInfo);
    }
    // 获取表单
    let carInfo = JSON.parse(sessionStorage.getItem("addcarInfo"));
    
    if (carInfo) {
      this.carInfo = carInfo;
    }
    //获取司机名称
    let depament = JSON.parse(localStorage.getItem("depament"));
    if (depament) {
      console.log("depament", depament);
      this.$set(this.carInfo, "driverName", depament[0].nickname);
      this.$set(this.carInfo, "driverCode", depament[0].username);
      this.$set(this.carInfo, "driverPhone", depament[0]?.phone);
      this.$set(this.carInfo, "oid", depament[0]?.oid);
    }
    localStorage.removeItem("depament");
    sessionStorage.removeItem("addcarInfo");
  },
  methods: {
    // 确认选择固定司机
    onConfirm(val){
      this.showPicker = false;
      this.carInfo.type = val
    },
    //确定选择 车牌
    onConfirmBrand(val){
      this.showPickerBrand = false;
      this.carInfo.brandType = val
    },
    // changeInput(value) {
    //   if (value > 6) {
    //     this.carInfo.maxCapacity = 6;
    //   }
    // },
    // 选择司机
    selectDriver() {
      sessionStorage.setItem("addcarInfo", JSON.stringify(this.carInfo)); // 跳转，存表单

      this.$router.replace("/car/facility/carManage/selectDriver");
    },
    //取消
    cancel() {
      // this.$router.replace({ path: "/car/facility/carManage" });
      // this.$router.go(-1);
      this.$router.replace("/car/facility/carManage");
    },
    //确认
    confirm() {
      this.$refs.form
        .validate()
        .then(() => {
          this.btnloading = true;
          let obj = this.carInfo;
          obj.type = obj.type == "是" ? 1 : 2;
          obj.brandType = obj.brandType == "是" ? 1 : 2;
          console.log("obj", obj);
          if (obj.id) {
            delete obj.freezeEndTime;
            delete obj.freezeStartTime;
            apis
              .editCarListInfo({ ...obj })
              .then((res) => {
                if (res.code == "200" && res.message == "success") {
                  this.$toast.success("提交成功");
                  this.$router.replace({ path: "/car/facility/carManage" });
                  // this.$router.go(-1);
                  this.btnloading = false;
                }
              })
              .catch(() => {
                this.btnloading = false;
                // this.$toast.fail(res.message);
              });
          } else {
            apis
              .insertCar({ ...obj })
              .then((res) => {
                if (res.code == "200" && res.message == "success") {
                  this.$toast.success("提交成功");
                  this.$router.replace("/car/facility/carManage");
                } else {
                  this.btnloading = false;
                  this.$toast.fail(res.message);
                }
              })
              .catch(() => {
                // this.$toast.fail('提交失败')
              });
          }
        })
        .catch(() => {});
    },
  },
  //组件销毁时，清除localStorage中的数据
  beforeDestroy() {
    localStorage.removeItem("driverCarInfo");
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  margin: auto;

  .carManageContainer {
    padding: 20px;
    padding-bottom: 80px;

    ::v-deep(.van-cell-group) {
      .van-cell {
        display: flex;
        flex-direction: column;
        padding: 18px 0;
      }

      .van-field__value {
        background-color: #f7f9fa;
        padding: 10px 20px;
      }

      .van-cell::after {
        content: "";
        border-bottom: 0;
      }

      .van-field__label {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
      }

      .van-field__label {
        width: 500px !important;
      }
    }

    ::v-deep .van-hairline--top-bottom::after {
      content: "";
      border: 0;
    }
  }

  @media screen and (max-width: 600px) {
    .footerBtn {
      width: 100%;
    }
  }

  @media screen and (min-width: 600px) {
    .footerBtn {
      width: 276px * $zoom;
    }
  }

  .footerBtn {
    position: fixed;
    bottom: 0;
    background-color: #f7f9fa;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }
}
</style>
